export const DEFAULT_MAX_RETRY_ATTEMPTS = 3;

export function parseRetryAttempts(value: number | string | undefined): number {
  if (value === undefined || (typeof value === 'string' && value.trim() === '')) {
    return DEFAULT_MAX_RETRY_ATTEMPTS;
  }
  const n = Number(value);
  if (!Number.isFinite(n) || !Number.isInteger(n) || n < 0) {
    return DEFAULT_MAX_RETRY_ATTEMPTS;
  }
  return n;
}
